import styled from 'styled-components';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useIsMobile } from '../../hooks/useIsMobile';
import {
  Text14Medium,
  Text18Medium,
  Text48Medium,
  TextInfo12,
} from '../../mixins/mixins';
import 'swiper/css';
import 'swiper/css/navigation';
import SwiperButtonNext from './SwiperButtonNext';
import SwiperButtonPrev from './SwiperButtonPrev';

const OfficeDescriptionComponent = styled.div`
  display: flex;
  flex-direction: column;
  background: white;
  color: rgba(7, 24, 43, 1);
  padding: 100px 0 96px;
  .prevTitle {
    color: rgba(7, 24, 43, 0.6);
    margin-bottom: 64px;
    margin-left: 24px;
    ${Text14Medium};
    @media (max-width: 669px) {
      ${TextInfo12};
    }
  }
  @media (max-width: 669px) {
    padding: 100px 0 0;
  }
`;

const TitleOffice = styled.div`
  width: 670px;
  ${Text48Medium};
  margin-bottom: 96px;
  margin-left: 24px;
  @media (max-width: 1023px) {
    width: unset;
  }
  @media (max-width: 669px) {
    margin-bottom: 31px;
    ${Text18Medium};
    width: 296px;
  }
`;

const PostWrapper = styled.div`
  display: flex;
  margin-right: 24px;
  margin-bottom: 76px;
  margin-left: 24px;
  @media (max-width: 1024px) {
    margin-right: 0;
    margin-bottom: 64px;
  }
  @media (max-width: 669px) {
    flex-direction: column;
  }
`;

const Post = styled.div`
  display: flex;
  width: 330px;
  margin-right: 124px;
  color: rgba(7, 24, 43, 0.6);
  ${Text18Medium};
  :last-child {
    margin-right: 0;
  }
  @media (max-width: 1024px) {
    margin-right: 24px;
  }
  @media (max-width: 669px) {
    margin-top: 24px;
  }
`;

const CardOffice = styled.div`
  min-height: 378px;
  @media (max-width: 669px) {
    min-height: 353px;
  }
`;

const NavigationWrapper = styled.div`
  position: absolute;
  bottom: 23px;
  display: flex;
  justify-content: center;
  width: 100%;
  :before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 1px;
    height: 64px;
    background: rgba(0, 0, 0, 0.2);
  }
`;

const SliderImage = styled.img`
  width: 100%;
`;

const OfficeDescription = () => {
  const isMobile = useIsMobile();
  return (
    <OfficeDescriptionComponent id="office">
      <span className="prevTitle">[Office]</span>
      <TitleOffice>Laoban group of companies</TitleOffice>
      <PostWrapper>
        <Post>
          LaoHe is located in Shenzhen - a strategic center that allows us to
          purchase goods with optimal delivery all over the world.
        </Post>
        <Post>
          We have a very responsible approach to the selection of our
          counterparties in international trade and we undertake full
          transaction support.
        </Post>
        <Post>
          The opportunity to conduct international negotiations without risks
          and losses for the client
        </Post>
      </PostWrapper>
      <CardOffice>
        <Swiper
          spaceBetween={24}
          slidesPerView={isMobile ? 1 : 2.1}
          centeredSlides={!isMobile}
          loop={true}
          navigation={true}
          modules={[Navigation]}
          className="swiper-office"
        >
          <SwiperSlide>
            <SliderImage src="/assets/img/OfficeImages/OfficeImage-1.png?react" />
          </SwiperSlide>
          <SwiperSlide>
            <SliderImage src="/assets/img/OfficeImages/OfficeImage-1.png" />
          </SwiperSlide>
          <SwiperSlide>
            <SliderImage src="/assets/img/OfficeImages/OfficeImage-1.png" />
          </SwiperSlide>
          <NavigationWrapper>
            <SwiperButtonPrev />
            <SwiperButtonNext />
          </NavigationWrapper>
        </Swiper>
      </CardOffice>
    </OfficeDescriptionComponent>
  );
};

export default OfficeDescription;
